// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-StudyList-StudyListExtractionMessage-StudyListExtractionMessage-module__heading";
var _2 = "webpack-pages-StudyList-StudyListExtractionMessage-StudyListExtractionMessage-module__wrap";
export { _1 as "heading", _2 as "wrap" }
